<template>
  <div>
    <el-dialog
    title="Excel 导入到数据库"
    :visible.sync="dialogVisible"
    width="60%"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleClose"
  >
    <el-form  ref="form">
      <el-form-item
        label="文件"
      >
        <UploadFile ref='upload' v-model='file'></UploadFile>
      </el-form-item>
    </el-form>
    <div class="btns">
      <el-button @click="sure">导入</el-button>
      <el-button @click="dowloadSign">下载模版</el-button>
      <el-button @click="handleWatch">查看导入异常日志</el-button>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <!-- <el-button type="primary" @click="sure">确 定</el-button> -->
    </span>
  </el-dialog>
  <HandleErrorLog ref='dialogErrorLog' :importStatus='importStatus' :editParams='editParams'></HandleErrorLog>
  </div>
</template>

<script>
import UploadFile from '@/components/uploadFileCopy';
import HandleErrorLog from './handle-error-log.vue';
import { importSignUp, importCertificate, downloadData } from '@/api/api'
export default {
  components: {
    UploadFile,
    HandleErrorLog
  },
  props: {
    importStatus:Number,
    editParams: {
      type: Object,
      default: function () {
        return {}
      },
    },
  },
  data() {
    return {
      dialogVisible: false,
      file:[],
    };
  },
  methods: {
    showDialog(componentName){
      this.$refs[componentName].setOpacity(true)
    },
    handleWatch(){
      this.showDialog('dialogErrorLog');
    },
    setOpacity(flg) {
      this.dialogVisible = flg;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    dowloadSign(){
      //报名1  合格2
      if( this.importStatus == 1 ){
        downloadData(
          `/radioweb/adm/classStudent/exportSignUp`,
          {classId: this.editParams.id}
        )
      }else{
        downloadData(
          `/radioweb/adm/classStudent/exportCertificate`,
          {classId: this.editParams.id}
        )
      }
    },
    sure(){
        // return false;
        console.log(this.editParams)
        var formData = new FormData();
        formData.append("file",this.file[0].file.raw);
        formData.append("classId",this.editParams.id);
        formData.append("name",this.file[0].name);
        if( this.importStatus == 1 ){
          importSignUp(formData).then((res) => {
            let { code, message } = res
            if (code === 0) {
              this.$refs.upload.clearFiles()
              this.$message.success('导入成功')
              this.dialogVisible = false;
              this.$emit('success',1)
            } else {
              this.$message.error(message)
            }
          })
        }else{

          importCertificate(formData).then((res) => {
            let { code, message } = res
            if (code === 0) {
              this.$refs.upload.clearFiles()
              this.$message.success('导入成功')
              this.dialogVisible = false;
              this.$emit('success',1)
            } else {
              this.$message.error(message)
            }
          })
        }

      }
  },
};
</script>

<style lang="scss">
.w50 {
  width: 50%;
  display: inline-block;
}
.el-dialog__body {
  // max-height: 50vh;
  overflow-y: auto;
}
</style>
